/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Diet_High_ProteinInputs */

const en_diet_high_protein = /** @type {(inputs: Diet_High_ProteinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`High protein`)
};

const de_diet_high_protein = /** @type {(inputs: Diet_High_ProteinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proteinreich`)
};

/**
* | output |
* | --- |
* | "High protein" |
*
* @param {Diet_High_ProteinInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const diet_high_protein = /** @type {((inputs?: Diet_High_ProteinInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Diet_High_ProteinInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_diet_high_protein(inputs)
	return en_diet_high_protein(inputs)
});